import { lazy } from '@atlassian/react-loosely-lazy';
import type { OrganizationsEdit } from './ui/edit/main.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyOrganizationsEdit = lazy<typeof OrganizationsEdit>(() =>
	import(/* webpackChunkName: "async-jira-issue-field-organizations-edit" */ './index').then(
		(module) => module.OrganizationsEdit,
	),
);
